import { PanelType, SelectionMode } from "@fluentui/react";
import { Guid, ReadonlyCollection, isNullOrEmpty } from "@ioip/core/lib";
import { List } from "linq.ts";
import { IAttributeSchema } from "../../data";
import { FormNotFoundException } from "../../exceptions";
import { ControlType } from "../../types/ControlType";
import { IDataTableColumnSchema } from "../../types/IDataTableColumn";
import CControl from "./CControl";
import { JSDataSource } from "./JSDataSource";
import { JSDataTableColumn } from "./JSDataTableColumn";
import { JSEngine } from "./JSEngine";
import { CForm } from "./JSForm";
import { IFieldSchema } from "./IFieldSchema";

export interface ICDataTableProps {
    engine: JSEngine;
    form: CForm;
    schema: IFieldSchema;
}

class CDataTable extends CControl {

    private __props: ICDataTableProps;
    private __columns: ReadonlyCollection<JSDataTableColumn> = null;
    private __datasource: JSDataSource;
    private __formId: Guid = null;

    constructor(props: ICDataTableProps) {
        super({ form: props.form, schema: props.schema, });
        this.__props = props;
        if (!isNullOrEmpty(this.__props.schema.formId))
            this.__formId = Guid.parse(this.__props.schema.formId);
    }

    get label(): string {
        return this.__props.schema.label;
    }

    get maxLength(): number {
        return this.__props.schema.maxLength;
    }

    get minLength(): number {
        return this.__props.schema.minLength;
    }

    get placeholder(): string {
        return this.__props.schema.placeholder;
    }

    get multiline(): boolean {
        return this.__props.schema.multiline;
    }

    get columns(): ReadonlyCollection<JSDataTableColumn> {
        if (this.__columns == null) {
            const form = this.__props.schema.controlType === ControlType.dataTable ? this.getForm() : null;
            const columns = new List<IDataTableColumnSchema>(this.__props.schema.columns || [])
                .OrderBy(schema => schema.order)
                .Select(schema => {
                    if (this.__props.schema.controlType === ControlType.entityDataTable) {
                        return new JSDataTableColumn({
                            datatable: this,
                            schema,
                            attribute: schema.attribute
                        });
                    } else {

                        const field = form.getField(schema.fieldId);
                        let attribute: IAttributeSchema = null;
                        if (field != null) {
                            const attributeId = field.attributeId;
                            // attribute = form.entity.getAttribute(attributeId)
                        };

                        return new JSDataTableColumn({
                            datatable: this,
                            schema,
                            attribute
                        });

                    }

                })
                .ToArray();
            this.__columns = new ReadonlyCollection<JSDataTableColumn>(columns);
        }
        return this.__columns;
    }

    get title(): string {
        return this.__props.schema.title;
    }

    get panelType(): PanelType {
        return this.__props.schema.panelType;
    }

    get selectionMode(): SelectionMode {
        return this.__props.schema.selectionMode || SelectionMode.none;
    }

    get panelTitle(): string {
        return this.__props.schema.panelTitle;
    }

    get formId(): Guid | null {
        return this.__formId;
    }

    get datasource(): JSDataSource {
        return this.__datasource;
    }

    /**
     * Obtiene el formulario asociado al control DataTable
     * @returns
     * @memberof JSDataTable
     * @throws FormNotFoundException
     */
    getForm(): CForm {
        if (this.formId == null)
            return null;
        const form = this.__props.form.page.getForm(this.formId, null, {});
        if (form == null)
            throw new FormNotFoundException(this.formId);
        return form;
    }

}

export default CDataTable;